import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { AlertTriangle, X } from 'lucide-react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const ImpersonationBanner = () => {
  const { user, stopImpersonating } = useAuth();
  const navigate = useNavigate();
  
  if (!user || user === false || !user.impersonator_id) return null;
  
  const handleStop = async () => {
    const ok = await stopImpersonating();
    if (ok) {
      toast.success('Tornato alla sessione admin');
      navigate('/admin');
    } else {
      toast.error('Errore');
    }
  };

  return (
    <div className="bg-yellow-500 text-yellow-950 px-4 py-2 flex items-center justify-center gap-3 sticky top-0 z-[100]" data-testid="impersonation-banner">
      <AlertTriangle className="w-4 h-4" />
      <span className="text-sm font-medium">
        Stai navigando come <strong>{user.name || user.email}</strong> (ruolo: {user.role})
      </span>
      <Button data-testid="stop-impersonate-btn" onClick={handleStop} size="sm" variant="outline" className="border-yellow-900 text-yellow-950 hover:bg-yellow-400 h-7">
        <X className="w-3 h-3 mr-1" /> Esci da modalità admin
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
